import {
  BRIDGE_API_NAME_SPACE,
  BRIDGE_READY_EVENT_NAME,
} from '../constants/namespace.js';
import { type WebviewJavascriptBridgeApi } from '../core/type.api.js';
import { logWarn } from '../utils/log.js';
import { isFabricWebview } from '../utils/webview.js';

/**
 * 提供bridge启动入口, 注意此处是异步返回bridge注册入口, 此处是异步ready.
 * 告知ios当前web注册的接口已ready, 如果是android则处理提前存储起来的native发送过来的消息.
 * 因为业务端并不知道什么时候bridge相关javascript环境是注册好了, 可以调用bridgeAPI
 * 封装入口, 只能从ready里面去调用
 * FIXME: 注意如果native存在主动调用webview注册的方法的可能性, 如果当前webview网页并为注册ready().
 * 可能会存在native缓存到队列里面的消息不断增长的内存泄漏问题, 如: onShow, onHide, onLoad
 */
export const ready = (
  callback?: (apis: Omit<WebviewJavascriptBridgeApi, 'webIsReady'>) => void
): void => {
  function runWrap(fabric: WebviewJavascriptBridgeApi) {
    if (typeof callback === 'function') {
      callback(fabric);
    }
    // Always run web bridge is ready, to handle pending messages from native call.
    fabric.webIsReady();
  }

  // 如果不在fabric webview容器 下面则无需ready
  if (!isFabricWebview()) {
    logWarn(
      `Invalid "ready()" invoke cause of the environment is not a "fabric" container!`
    );
    return;
  }

  if (window[BRIDGE_API_NAME_SPACE]) {
    runWrap(window[BRIDGE_API_NAME_SPACE]);
  } else {
    document.addEventListener(
      BRIDGE_READY_EVENT_NAME,
      (e) => {
        runWrap(e['fabric']);
      },
      false
    );
  }
};
